import { apiClient } from '../client';
import { API_ENDPOINTS } from '../config';

interface LoginCredentials {
  email?: string;
  phone?: string;
  password?: string;
}

interface SSOResponse {
  authUrl: string;
}

interface OTPResponse {
  success: boolean;
  message: string;
}

interface AuthResponse {
  success: boolean;
  token: string;
  user: any;
}

class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(API_ENDPOINTS.auth.login, credentials);
    if (response.token) {
      apiClient.setAuthToken(response.token);
    }
    return response;
  }

  async logout(): Promise<void> {
    await apiClient.post(API_ENDPOINTS.auth.logout);
    apiClient.setAuthToken(null);
    apiClient.clearCache();
  }

  async refreshToken(): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(API_ENDPOINTS.auth.refresh);
    if (response.token) {
      apiClient.setAuthToken(response.token);
    }
    return response;
  }

  async initiateSSOLogin(provider: 'google' | 'microsoft'): Promise<SSOResponse> {
    return apiClient.post<SSOResponse>(API_ENDPOINTS.auth.sso.workos, { provider });
  }

  async handleSSOCallback(code: string, state: string): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(API_ENDPOINTS.auth.sso.callback, { code, state });
    if (response.token) {
      apiClient.setAuthToken(response.token);
    }
    return response;
  }

  async sendOTP(phoneNumber: string): Promise<OTPResponse> {
    return apiClient.post<OTPResponse>(API_ENDPOINTS.auth.otp.send, { phoneNumber });
  }

  async verifyOTP(phoneNumber: string, code: string): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(API_ENDPOINTS.auth.otp.verify, { phoneNumber, code });
    if (response.token) {
      apiClient.setAuthToken(response.token);
    }
    return response;
  }

  setToken(token: string | null) {
    apiClient.setAuthToken(token);
  }
}

export const authService = new AuthService();